import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { DepletionTypeService } from '../proxy/controlling/controllers/depletion-type.service';
import { ContractTypeService } from '../proxy/controlling/controllers/contract-type.service';
import { AssetService } from '../proxy/controlling/controllers/asset.service';
import { MonthService } from '@general/proxy/general/controllers';

FieldBuilder.setNamespace('Controlling');

export const DEPLETIONEXCHANGEAMOUNT_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .number('year', 'Entity.DepletionExchangeAmount.Year')
    .required()
    .build(),
  FieldBuilder.foreignKey(
    'assetId',
    'Entity.Asset',
    AssetService
  )
    .displayFromNested('asset.name')
    .sortBy('asset.name')
    .build(),
  FieldBuilder
    .checkbox('isOwnPlantation', 'Entity.DepletionExchangeAmount.IsOwnPlantation')
    .build(),
  FieldBuilder
    .number('usdAmount', 'Entity.DepletionExchangeAmount.UsdAmount')
    .decimal(3,25)
    .build(),
  FieldBuilder
    .number('uyuAmount', 'Entity.DepletionExchangeAmount.UyuAmount')
    .decimal(3,25)
    .build(),
  FieldBuilder
    .number('euroAmount', 'Entity.DepletionExchangeAmount.EuroAmount')
    .decimal(3,25)
    .build(),
  FieldBuilder
    .number('exchangeType', 'Entity.DepletionExchangeAmount.ExchangeType')
    .decimal(3,10)
    .build(),
  FieldBuilder
    .number('euroExchangeType', 'Entity.DepletionExchangeAmount.EuroExchangeType')
    .decimal(3,10)
    .build(),
  FieldBuilder.foreignKey(
    'depletionTypeId',
    'Entity.DepletionType',
    DepletionTypeService
  )
    .displayFromNested('depletionType.name')
    .sortBy('depletionType.name')
    .build(),
  FieldBuilder.foreignKey(
    'contractTypeId',
    'Entity.ContractType',
    ContractTypeService
  )
    .displayFromNested('contractType.name')
    .sortBy('contractType.name')
    .build(),
  FieldBuilder.foreignKey( // TODO: when the orchestrator is implemented, refactor this nested logic into it
    'monthId',
    'Entity.DepletionExchangeAmount.Month',
    MonthService
  )
    .required()
    .displayFromNested('month.name')
    .sortBy('month.name')
    .build(),
];

export const DEPLETIONEXCHANGEAMOUNT_CONFIG = {
  entityName: 'DepletionExchangeAmount',
  localizationKey: 'Controlling::Entity.DepletionExchangeAmount',
  fields: DEPLETIONEXCHANGEAMOUNT_FIELDS,
  permission: 'ControllingLiquidations.DepletionExchangeAmounts',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
